import { Fragment, useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

const HELP_TOPICS = ["About US", "Games", "Deposit", "Withdrawal", "Terms and Conditions"];

function HelpContent({ tab }) {
  if (tab === "About US") {
    return (
      <>
        <h2 id="ref-about-title">Welcome to chorki</h2>
        <h3>-- award-winning online gaming provider.</h3>
        <p>
          Established in 2006, chorki quickly developed its brand and reputation as a market leader in
          the global online gaming industry. The brand was founded with the principles of trust and
          credibility at its core, defining the ethos for all company activities to this day.
        </p>
        <p>
          chorki has consistently demonstrated a clear focus on enriching your gaming experience. Our
          products offer a wide variety of online gaming brands, each providing its own unique,
          entertaining and exciting range of games and opportunities.
        </p>
        <h3>Is it legal?</h3>
        <p>
          We run our casino under the Philippines gaming license, issued by the PAGCOR. The PAGCOR is
          an independent regulatory body that makes sure casinos adhere to the practices and
          regulations that apply to online casinos.
        </p>
        <p>
          This means we follow rigorous practices when it comes to player protection and responsible
          gaming, and that our players are protected by the law.
        </p>
        <h3>Is it secure?</h3>
        <p>
          Yes! We monitor around the clock all year. We adhere to the highest security standards and
          implement them in every area of our activity, ensuring the safety and integrity of your
          personal information at all times.
        </p>
      </>
    );
  }

  if (tab === "Games") {
    return (
      <>
        <h2 id="ref-about-title">Here at chorki, we provide a wide range of games</h2>
        <h3>Live Casino</h3>
        <p>Real dealers, real action and real wins. It is the closest you can get to playing in a real casino!</p>
        <ul>
          <li>Roulette: Place chips on your favourite numbers and see if Lady Luck is on your side!</li>
          <li>Blackjack: Get as close as you can to a total of 21, but be careful you do not go bust!</li>
          <li>Baccarat: Step up to the Baccarat table and test your skills!</li>
        </ul>
        <h3 className="reference-help-spaced">Slot Games</h3>
        <p>
          With a simple format and fun features, online slots offer a relaxed, low-pressure gaming
          experience. There are tons of games to choose from, and you can always find the one you like.
        </p>
        <p>
          Each game has its own instructions, so even if you have never played slots online before,
          you will quickly understand which symbols to look out for and how paylines work.
        </p>
        <p>
          Many online slots have free spins rounds where you can spin the reels without staking your
          cash and exciting features that offer more chances to win cash prizes.
        </p>
      </>
    );
  }

  if (tab === "Deposit") {
    return (
      <>
        <h2 id="ref-about-title">Deposit</h2>
        <p>
          The deposit options offered may vary depending on your country of residence. For accurate
          information on the methods available to you, please visit the member center.
        </p>
        <p>You will get the balance within 5 minutes in most cases.</p>
        <h3>Available Deposit Time</h3>
        <p>Open for 24 hours</p>
        <h3>Deposit Amount Limit</h3>
        <p><strong>Bank Transfer:</strong> minimum 50 USD or equal, maximum 2000 USD or equal</p>
        <p><strong>Other:</strong> minimum 80 USD or equal, maximum 3000 USD or equal</p>
        <h3>Methods of Payment</h3>
        <p>What we support: bank transfer and other</p>
        <p>
          We are working on the payment solutions. If you do not get the balance within 20 minutes,
          please contact us for further information.
        </p>
      </>
    );
  }

  if (tab === "Withdrawal") {
    return (
      <>
        <p><strong>Minimum per request:</strong> 100 USD or equal.</p>
        <p><strong>Maximum per day:</strong> 100,000 USD or equal.</p>
        <p><strong>Note:</strong> you have to reach the turnover to have a withdrawal request.</p>
        <h3 className="reference-help-spaced">Withdrawal fee</h3>
        <p>We do not charge anything for withdrawing.</p>
        <h3 className="reference-help-spaced">Failing on withdrawal?</h3>
        <ul>
          <li>If you have reached the turnover for withdrawal?</li>
          <li>If you have an active bonus, you cannot withdraw your bonus balance until the bonus is complete.</li>
          <li>If you provide the wrong bank information or the bank is frozen?</li>
        </ul>
        <h3>How to edit my personal information?</h3>
        <p>Please contact customer support to change the correct bank account, payee name and so on.</p>
      </>
    );
  }

  return (
    <>
      <h3 id="ref-about-title">Transaction agreement</h3>
      <ol className="reference-help-terms">
        <li>
          In order to avoid disputes when betting on this website, members must read the rules set by
          this platform before entering the website. Once the customer enters this website with
          “I agree” to place a bet, it is deemed to have accepted this entertainment agreement and
          rules of the platform.
        </li>
        <li>
          Please modify your login password regularly. Members are responsible for ensuring the
          confidentiality of their account and login information. Any online betting made with a
          member account and password will be considered valid.
        </li>
        <li>
          Betting related terms:
          <ol>
            <li>If online betting is not successfully submitted, the bet will be considered invalid.</li>
            <li>If the player is disconnected and there is no result, it will not affect the result of the draw settlement.</li>
            <li>If there is no prize draw on the official website or the result is wrong, the platform will recalculate the result.</li>
            <li>In the event of network problems or force majeure, the announcement on this platform is the final plan.</li>
            <li>This platform records all electronic transactions and the betting record is the standard.</li>
          </ol>
        </li>
        <li>
          If a member uses improper methods, plug-ins, automated programs, vulnerabilities or other
          behaviour harmful to the platform, the platform reserves the right to cancel all bets and
          permanently suspend the member account.
        </li>
      </ol>
    </>
  );
}

const Footer = () => {
  const navigate = useNavigate();
  const [aboutOpen, setAboutOpen] = useState(false);
  const [helpTab, setHelpTab] = useState("About US");
  const tabsRef = useRef(null);
  const openHelp = (tab) => {
    setHelpTab(tab);
    setAboutOpen(true);
  };
  useEffect(() => {
    if (!aboutOpen) return undefined;
    const nav = tabsRef.current;
    if (!nav) return undefined;
    const mark = () => {
      const max = nav.scrollWidth - nav.clientWidth;
      nav.classList.toggle("can-scroll-left", nav.scrollLeft > 8);
      nav.classList.toggle("can-scroll-right", max - nav.scrollLeft > 8);
    };
    const frame = requestAnimationFrame(() => {
      nav.querySelector(".active")?.scrollIntoView({ inline: "nearest", block: "nearest" });
      mark();
    });
    nav.addEventListener("scroll", mark, { passive: true });
    return () => {
      cancelAnimationFrame(frame);
      nav.removeEventListener("scroll", mark);
    };
  }, [aboutOpen, helpTab]);
  useEffect(() => {
    if (!aboutOpen) return undefined;
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    const close = event => { if (event.key === "Escape") setAboutOpen(false); };
    document.addEventListener("keydown", close);
    return () => {
      document.body.style.overflow = previousOverflow;
      document.removeEventListener("keydown", close);
    };
  }, [aboutOpen]);
  return (
    <Fragment>
      <div className="br_footer_main">
        <div className="reference-provider-logos" aria-label="Game providers">
          {"JL PG SPB FC BNG JDB MG NG L22 SG FP BGA 5G MAS GM MA FTG PS SS YB".split(" ").map(provider => <img key={provider} src={`/assets/bdtwin/${provider}-COLOR.png`} alt={provider} />)}
        </div>
        <nav className="ref-footer-links" aria-label="Information">
          <button type="button" onClick={() => openHelp("About US")}>About US</button>
          <button type="button" onClick={() => openHelp("Games")}>Games</button>
          <button type="button" onClick={() => openHelp("Deposit")}>Deposit</button>
          <button type="button" onClick={() => openHelp("Withdrawal")}>Withdrawal</button>
          <button type="button" onClick={() => openHelp("Terms and Conditions")}>Terms and Conditions</button>
          <button type="button" onClick={() => navigate("/affiliate-register")}>Affiliate</button>
        </nav>
        {aboutOpen && (
          <div
            className="ref-about-overlay"
            role="dialog"
            aria-modal="true"
            aria-labelledby="ref-about-title"
            onMouseDown={event => { if (event.target === event.currentTarget) setAboutOpen(false); }}
          >
            <div className="reference-help-dialog">
              <h2 className="reference-help-heading"><i aria-hidden="true" />Help Center</h2>
              <button className="reference-help-close" type="button" aria-label="Close Help Center" onClick={() => setAboutOpen(false)}>×</button>
              <nav className="reference-help-tabs" aria-label="Help topics" ref={tabsRef}>
                {HELP_TOPICS.map(topic => (
                  <button
                    type="button"
                    key={topic}
                    className={helpTab === topic ? "active" : ""}
                    aria-current={helpTab === topic ? "page" : undefined}
                    onClick={() => setHelpTab(topic)}
                  >
                    <i aria-hidden="true" />
                    <span>{topic}</span>
                    <b aria-hidden="true">{helpTab === topic ? "⌄" : "›"}</b>
                  </button>
                ))}
              </nav>
              <section className="reference-help-content" tabIndex={0} aria-label="Help topic content">
                <HelpContent tab={helpTab} />
              </section>
            </div>
          </div>
        )}

        <div className="copyright">
          Copyright © {new Date().getFullYear()} chorki. All Rights Reserved.
        </div>
      </div>{" "}
      <div style={{ display: "contents" }}>
        <div id="mini-game-container" className="mini-game-container" /> {/**/}
      </div>
    </Fragment>
  );
};

export default Footer;
